import React, { useState, useEffect } from "react";
import Quiz from "./Quiz";


const Home = () => {
  const [showHeader, setShowHeader] = useState(true);

  useEffect(() => {
    const showHeaderStored = localStorage.getItem("showHeader");
    if (showHeaderStored === "false") {
      setShowHeader(false);
    }
  }, []);

  const handleQuizComplete = () => {
    setShowHeader(false);
    localStorage.setItem("showHeader", "false");
  };

  return (
    <div style={{ fontFamily: "Work Sans, sans-serif" }}>
   
      <Quiz onQuizComplete={handleQuizComplete} />
    </div>
  );
};

export default Home;
